import React from 'react';
import { Dialog, DialogContent } from '@roger/ui-components';
import { Patient } from '../store/slices/patientsSlice';
import { calculateAge } from '../utils/dateUtils';

interface PatientSnapshotDialogProps {
  patient: Patient | null;
  open: boolean;
  onClose: () => void;
}

const PatientSnapshotDialog: React.FC<PatientSnapshotDialogProps> = ({
  patient,
  open,
  onClose,
}) => {
  const getAge = (dob: string) => calculateAge(dob) ?? '--';

  if (!patient) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className='w-[calc(100vw-2rem)] sm:max-w-md'>
        <div className='flex items-center justify-between mb-2'>
          <div className='text-lg font-semibold'>{patient.name}</div>
        </div>
        <div className='space-y-1 text-sm'>
          <div>
            <span className='font-medium text-muted-foreground'>MRN:</span>{' '}
            {patient.mrn || 'N/A'}{' '}
            <span className='ml-4 font-medium text-muted-foreground'>Age:</span>{' '}
            {getAge(patient.date_of_birth)}
          </div>
          <div>
            <span className='font-medium text-muted-foreground'>Phone:</span>{' '}
            {patient.phone || 'N/A'}
          </div>
          <div>
            <span className='font-medium text-muted-foreground'>Address:</span>{' '}
            {patient.address || 'N/A'}
          </div>
          <div className='pl-[54px]'>
            {[patient.city, patient.state].filter(Boolean).join(', ') || 'N/A'}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PatientSnapshotDialog;
